import React from 'react';
import { Group, Text } from 'react-konva';
import { SpotShape } from '../../../../types';
import { SpotLayout } from '../../types';

export type CircleProfilePhotoProps = {
  label: string;
  radius: number;
  layout: SpotLayout;
  shape: SpotShape;
};

export const CircleSelectionNumber: React.FC<CircleProfilePhotoProps> = ({
  label,
  layout,
  radius: circleRadius
}) => {
  const maxFontSize = circleRadius * 0.8;
  const textWidth = circleRadius * 1.5;
  const textHeight = circleRadius * 1.5;

  return (
    <Group
      x={layout.circle.x - circleRadius}
      y={layout.circle.y - circleRadius}
      width={circleRadius * 2}
      height={circleRadius * 2}
      clipFunc={(ctx) => {
        ctx.arc(
          circleRadius,
          circleRadius,
          circleRadius,
          0,
          Math.PI * 2,
          false
        );
        ctx.closePath();
      }}
    >
      {label && (
        <Text
          text={label}
          fontSize={maxFontSize}
          align="center"
          verticalAlign="middle"
          width={textWidth}
          height={textHeight}
          x={(circleRadius * 2 - textWidth) / 2}
          y={(circleRadius * 2 - textHeight) / 2}
          fill={'white'}
          fontStyle={'bold'}
        />
      )}
    </Group>
  );
};
